import { useMemo } from "react";
import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isWeb } from "@tamagui/core";
import { Dialog as TamaguiDialog } from "@tamagui/dialog";
import { useWindowDimensions } from "react-native-web";
import { getOpacityTokenValue, getPercentageTokenValue } from "../../helpers/tokens";
import { Box } from "../Box";
import { CloseButton } from "../Button";
import { BackgroundBlur } from "./BackgroundBlur";
import { jsx, jsxs } from "react/jsx-runtime";
const { dialog: dialogTokens } = tokens, Dialog = ({
  isOpen,
  animation = "accelerateDecelerateFastest",
  setIsOpen,
  overlayColor = "dark",
  analyticsName,
  trackImpression,
  dismissable = !0,
  showCloseButton = !0,
  children
}) => {
  const overlayProps = overlayColor === "dark" ? { backgroundColor: dialogTokens.color.scrim } : overlayColor === "transparent" ? { backgroundColor: void 0 } : {
    backgroundColor: dialogTokens.color.scrimInverse,
    children: /* @__PURE__ */ jsx(
      BackgroundBlur,
      {
        blurRadius: dialogTokens.backgroundBlur.default,
        style: { position: "absolute", top: 0, bottom: 0, right: 0, left: 0 }
      }
    )
  }, maxHeightTokenValue = getPercentageTokenValue(dialogTokens.percentage.maxHeight), minHeightTokenValue = getPercentageTokenValue(dialogTokens.percentage.minHeightWidth), dimensions = useWindowDimensions(), maxSheetHeight = useMemo(() => {
    const percent = parseInt(maxHeightTokenValue, 10);
    return isWeb ? `${percent}dvh` : 0.01 * percent * dimensions.height;
  }, [dimensions.height, maxHeightTokenValue]), minSheetHeight = useMemo(() => {
    const percent = parseInt(minHeightTokenValue, 10);
    return isWeb ? `${percent}dvh` : 0.01 * percent * dimensions.height;
  }, [dimensions.height, minHeightTokenValue]);
  return /* @__PURE__ */ jsxs(
    TamaguiDialog,
    {
      modal: !0,
      open: isOpen,
      onOpenChange: dismissable ? setIsOpen : void 0,
      children: [
        /* @__PURE__ */ jsxs(TamaguiDialog.Portal, { children: [
          /* @__PURE__ */ jsx(
            TamaguiDialog.Overlay,
            {
              animation,
              animateOnly: ["opacity"],
              enterStyle: { opacity: 0 },
              exitStyle: { opacity: 0 },
              ...overlayProps
            },
            "overlay"
          ),
          /* @__PURE__ */ jsx(
            TamaguiDialog.Content,
            {
              animation,
              animateOnly: ["opacity", "transform"],
              enterStyle: { opacity: 0, y: 20 },
              exitStyle: { opacity: 0, y: 20 },
              overflow: "hidden",
              padding: 0,
              borderWidth: 0,
              backgroundColor: dialogTokens.color.background.default,
              borderRadius: dialogTokens.cornerRadius.desktop.default,
              minWidth: getPercentageTokenValue(dialogTokens.percentage.minHeightWidth),
              minHeight: minHeightTokenValue,
              maxHeight: maxHeightTokenValue,
              $largerThanSM: {
                maxWidth: getPercentageTokenValue(dialogTokens.percentage.maxWidth)
              },
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  analyticsName,
                  trackImpression,
                  flexGrow: 1,
                  flexShrink: 1,
                  position: "relative",
                  children: [
                    dismissable && showCloseButton && /* @__PURE__ */ jsx(TamaguiDialog.Close, { asChild: !0, children: /* @__PURE__ */ jsx(
                      CloseButton,
                      {
                        size: "large",
                        analyticsName: `${analyticsName}-close`,
                        position: "absolute",
                        zIndex: 1,
                        top: 0,
                        right: 0,
                        margin: dialogTokens.padding.actions.closeIconButton.desktop
                      }
                    ) }),
                    children
                  ]
                }
              )
            },
            "content"
          )
        ] }),
        /* @__PURE__ */ jsx(TamaguiDialog.Adapt, { when: "smallerThanMD", children: /* @__PURE__ */ jsxs(
          TamaguiDialog.Sheet,
          {
            modal: !0,
            dismissOnSnapToBottom: dismissable,
            moveOnKeyboardChange: !0,
            dismissOnOverlayPress: dismissable,
            disableDrag: !dismissable,
            animation,
            snapPointsMode: "fit",
            children: [
              /* @__PURE__ */ jsx(
                TamaguiDialog.Sheet.Overlay,
                {
                  animation,
                  animateOnly: ["opacity"],
                  enterStyle: { opacity: 0 },
                  exitStyle: { opacity: 0 },
                  ...overlayProps
                },
                "overlay"
              ),
              dismissable && /* @__PURE__ */ jsx(
                TamaguiDialog.Sheet.Handle,
                {
                  borderRadius: dialogTokens.cornerRadius.mobile.handle,
                  height: dialogTokens.mobile.handle.height,
                  width: dialogTokens.mobile.handle.width,
                  alignSelf: "center",
                  marginLeft: 0,
                  marginRight: 0,
                  marginBottom: dialogTokens.margin.mobile.handle.bottom,
                  backgroundColor: overlayColor === "dark" ? dialogTokens.color.background.mobile.handle : dialogTokens.color.background.mobile.handleInverse,
                  opacity: getOpacityTokenValue(dialogTokens.opacity.mobileHandle)
                }
              ),
              /* @__PURE__ */ jsx(
                TamaguiDialog.Sheet.Frame,
                {
                  backgroundColor: dialogTokens.color.background.default,
                  borderTopLeftRadius: dialogTokens.cornerRadius.mobile.default,
                  borderTopRightRadius: dialogTokens.cornerRadius.mobile.default,
                  maxHeight: maxSheetHeight,
                  minHeight: minSheetHeight,
                  children: /* @__PURE__ */ jsx(TamaguiDialog.Adapt.Contents, {})
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
export {
  Dialog
};
